import { render, staticRenderFns } from "./OutputSearchStrategy.vue?vue&type=template&id=f5c71c5e&scoped=true"
import script from "./OutputSearchStrategy.vue?vue&type=script&lang=js"
export * from "./OutputSearchStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c71c5e",
  null
  
)

export default component.exports